import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../../../baseClasses/BaseComponent'; 
import Card from '../../../../components/Card';
import Arrow from '../../../../assets/images/arrow-button.svg';
import buildIconGray from '../../../../assets/images/build-icon-gray.svg';
import taskIconGray from '../../../../assets/images/task-icon-gray.svg';
import PopupMenu from '../../../../components/PopupMenu';
import dataModel from '../../../../models/DataModel';
import LoadingDots from '../../../../components/LoadingDots';
import DataSource from '../../../../dao/DataSource/DataSource';
import { build_card } from '../../../../dao/BuildsDAO';
import './BuildDetailCard.scss';
import Input from '../../../../components/Input';
import CopyBuildPopout from '../../../../components/CopyBuildPopout';

// Change BuildDetailCard to the appropriate name
class BuildDetailCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
      menu: null, 
      openEditOptions: false,
      build: null,
      displayCopyPopout: false,
    };
    this.doDeleteBuild = this.doDeleteBuild.bind(this);
    this.handleCopyPopupOpen = this.handleCopyPopupOpen.bind(this);
    this.handleCopyPopupClose = this.handleCopyPopupClose.bind(this);
  }

  handleBuildRetrieval(build) {
    this.setState({ build });
    if (this.titleInput) {
      this.titleInput.focus();
    }
  }
  
  componentDidMount() {
    super.componentDidMount(this);
    if (!this.props.buildId >= 0) {
      this.buildDataSource = new DataSource('Build', this.props.buildId, build_card, this.handleBuildRetrieval);
      this.buildDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.buildId != this.props.buildId) {
      if (this.buildDataSource) {
        this.buildDataSource.release();
      }
      this.buildDataSource = new DataSource('Build', this.props.buildId, build_card, this.handleBuildRetrieval);
      this.buildDataSource.get();
    }
  }

  handleCloseMenu() {
    if (this.state.menu) {
      this.setState({ menu: null });
    }
  }

  doDeleteBuild() {
    this.buildDataSource.delete().then(() => {
      if (this.props.onDeleteBuild) {
        this.props.onDeleteBuild(this.state.build);
      }
    });
  }

  queryDeleteBuild() {
    let message = this.textMap.buildDeleteQuestion;
    
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      cancelButtonText: this.textMap.cancel, 
      okButtonText: this.textMap.deleteBuild,
      width: 300, 
      height: 175, 
      message: message,
      handleOwnerOk: () => {
        this.doDeleteBuild();
      },
    });
  }

  handleEditBuild() {
    const editedBuild = Object.assign({}, this.state.build);
    this.setState({ 
      editBuild: editedBuild,
    });
  } 

  handleCopyPopupOpen() {
    this.setState({ displayCopyPopout: true });
  }
  handleCopyPopupClose() {
    this.setState({ displayCopyPopout: false });
  }
  
  handleMenuSelection(type) {
    switch (type) {
    case 'delete':
      this.queryDeleteBuild();
      break;
    case 'copy':
      this.handleCopyPopupOpen();
      break;
    case 'edit':
      this.handleEditBuild();
      break;
    default:
      break;
    }
  }
  
  handleBuildSelection(select) {
    if (!this.state.editBuild && !this.dragging) {
      const { build } = this.state;
      const { selectBuild } = this.props;
      if (selectBuild) {
        // Null will deselect any currently selected build
        selectBuild(build);
      }
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleBuildUpdate();
    }
    else if (e.keyCode == 27) {
      this.handleEditCancel();
    }
  }

  handleExpandClick(e) {
    e.stopPropagation();
    const { handleBuildExpand } = this.props;
    if (handleBuildExpand) {
      handleBuildExpand(this.state.build);
    }
  }

  createMoreMenu() {
    let menuOptions = [];
    const { canEditProject, canDeleteProject, canCopyProject } = this.props.permissions;
    
    if(canEditProject) {
      menuOptions.push({
        type: 'edit',
        name: this.textMap.editBuild,
      });
    }
    if(canCopyProject) {
      menuOptions.push({
        type: 'copy',
        name: this.textMap.copy,
      });
    }
    if(canDeleteProject) {
      menuOptions.push({
        type: 'delete',
        name: this.textMap.deleteBuild,
      });
    }

    let left = 335;
    const element = document.getElementById('menu-' + this.state.build.id);
    if (element) {
      const rect = element.getBoundingClientRect();
      const parentRect = element.parentElement.getBoundingClientRect();
      left = (rect.left - parentRect.left) + rect.width + 15;
    }
    const menu = (
      <PopupMenu 
        left={left + 15} 
        top={80} 
        width={150} 
        menuOptions={menuOptions} 
        size="smaller"
        menuId="project_templateMenu" 
        popupOnHover={false} 
        handleMenuSelection={this.handleMenuSelection}
        handleClickAway={this.handleCloseMenu} 
        pointerPosition="left" 
      />
    );
    return menu;
  }

  handleMoreButton(e) {
    e.stopPropagation();
    if (!this.state.menu) {
      const menu = this.createMoreMenu();
      this.setState({ menu: menu });
    }
    else {
      this.setState({ menu: null });
    }
  }

  handleNameChange(e) {
    const editedBuild = Object.assign({}, this.state.editBuild, { name: e.target.value });
    this.setState({ editBuild: editedBuild, nameChanged: e.target.value && e.target.value != this.state.build.name  });
  }

  async handleBuildUpdate() {
    if (this.state.editBuild) { 
      let editedBuild = Object.assign({}, this.state.editBuild);
      this.setState({ build: editedBuild });
      this.buildDataSource.update(editedBuild);
      this.handleEditCancel();
    }
  }

  handleValidation(string){
    let pass = false;  
    if (string && string.length > 0 && string.trim() != ''){
      pass = true;
    }
    return pass;
  }

  handleEditCancel() {
    this.setState({ editBuild: null, nameChanged: false, userAssignmentsChanged: false });
  }

  handleBlur() {
    this.setState({ editBuild: null });
  }

  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.cardElement;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (!this.dragging && this.dragElement && this.dragElement == element && !this.dragObject) {
      this.dragging = true;
      let bodyElement = document.body;
      // if (this.props.dragParentId) {
      //   bodyElement = document.getElementById(this.props.dragParentId)
      // }
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 1000;
      this.dragObject.style.opacity = .8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    this.dragObject.style.top = top + 'px';
    if (this.props.handleDragging) {
      this.props.handleDragging(this.state.build, this.xPos, top);
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    // if (this.props.dragParentId) {
    //   bodyElement = document.getElementById(this.props.dragParentId)
    // }
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    this.dragObject = null;
    if (this.props.handleDropping) {
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.state.build, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    if (this.props.permissions.canEditProjectTemplate && !this.props.readOnly) {
      e = this.fixupMouse(e);
      if (e.which == 1) {
        this.handlePrepareDrag(e.clientX, e.clientY);
        document.body.classList.add('no-select');
      }
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (!this.dragging && e.which == 1) {
      if ((this.startX && Math.abs(this.startX - e.clientX) > 5) ||
        (this.startY && Math.abs(this.startY - e.clientY) > 5)) {
        this.handleStartDrag(this.cardElement);
      }
    }
  }

  render() {
    let { left, top, expanded, selected } = this.props;
    const { build } = this.state;

    let loadingDots = null;
    if (!build) {
      loadingDots = <div className='loading-dots'>
        <LoadingDots smaller={true} />
      </div>;
    }

    let displayBuild = this.state.editBuild ? this.state.editBuild : build ? build : { id: this.props.buildId, name: '', tasks_completed_count: 0, tasks_count: 0, builds: [] };
    this.photoCount = 0;
    this.commentsCount = 0;

    const selectedClass = selected ? ' selected' : '';

    let userImageContainer = null;

    const classNames = 'template-build-detail-card ' + (this.state.editBuild ? ' editing' : '');

    let arrowClass = 'arrow-button ';
    let expandedClass = '';
    if (expanded) {
      arrowClass += 'expanded';
      expandedClass = ' expanded';
    }
    let menu;
    if (this.state.menu){
      menu = this.state.menu;
    }
    let buttonList = null;
    if (this.props.fromProjectTemplate) {
      buttonList =
      (<div className="build-button-list">
          <div className="button build-task-button">
            <img src={taskIconGray} alt="" />
          </div>
          <span className="build-label">{displayBuild.tasks_count}</span>
          <div className="button build-build-button">
            <img src={buildIconGray} alt="" />
          </div>
          <span className="build-label">{displayBuild.builds.length}</span>
        </div>
        );
    }
    else if (!this.state.editBuild) {
      let buildStyle;
      if (displayBuild.builds && displayBuild.builds.length == 0) {
        buildStyle = { display: 'none' };
      }
      buttonList = <div className="build-button-list">
        <div className="button build-task-button">
          <img src={taskIconGray} alt="" />
        </div>
        <span className="build-label">{(displayBuild.tasks_completed_count ? displayBuild.tasks_completed_count : 0) + '/' + displayBuild.tasks_count}</span>
        <div className="button build-build-button" style={buildStyle}>
          <img src={buildIconGray} alt="" />
        </div>
        <span className="build-label" style={buildStyle}>{displayBuild.builds ? displayBuild.builds.length : 0}</span>
      </div>;
    }

    let moreButton = null;
    if (!this.state.editBuild && this.props.permissions.canEditProjectTemplate && !this.props.readOnly) {
      moreButton = <div className="menu" id={'menu-' + this.props.buildId} onClick={this.handleMoreButton} />;
    }
    let cardFooter = null;

    let expansionArrow = null;
    /** comment out build nesting feature - might revert later */
    // if (!this.state.editBuild && !this.props.readOnly && (this.props.permissions.canEditProjectTemplate || (build.builds && build.builds.length > 0))) {
    //   expansionArrow = <div className="expand-click-area" onClick={this.handleExpandClick} >
    //     <img src={Arrow} className={arrowClass} alt="arrow" />
    //   </div>
    // }

    let buildNameView = null;
    let action = null;
    let progressIndicator = null;
    const disabled = !(this.state.nameChanged || this.state.userAssignmentsChanged);

    if (this.state.editBuild) {

      let saveButton = <div className={'save-button' + (disabled ? ' disabled' : '')} onClick={!disabled ? this.handleBuildUpdate : null}>{this.textMap.save.toUpperCase()}</div>;
      let cancelButton = <div className='cancel-button' onClick={this.handleEditCancel}>{this.textMap.cancel.toUpperCase()}</div>;
      action = <div className='actions'>
        {cancelButton}
        {saveButton}
      </div>;

      let validated = this.handleValidation(this.state.editBuild.name);
      if (validated) {
        saveButton = <div className='save-button' onClick={this.handleBuildUpdate}>{this.textMap.save}</div>;
      }
      buildNameView = <div className="entry-field">
        <div className="card-caption field">
          <Input className="input-field build-title-input" value={this.state.editBuild.name} onChange={this.handleNameChange}
          onKeyDown={this.handleKeyDown} ref={(element) => {
            this.titleInput = element;
          }} />
        </div>
      </div>;  
    }
    else {
      buildNameView = <div className="card-caption">
        {loadingDots}
        <span className="card-title" title={displayBuild.name}>{displayBuild.name}</span>
      </div>;

      const buildPercent = Math.round((displayBuild.tasks_completed_count ? displayBuild.tasks_completed_count : 0) * 100 / displayBuild.tasks_count);
      let backColor = buildPercent == 100 ? '#5DB348' : buildPercent > 0 ? '#f5a623' : '#9b9b9b';
      const measureStyle = { width: buildPercent + '%', borderBottom: '4px solid ' + backColor };

      progressIndicator = <div className="card-underline">
        <div className="card-measure-back"></div>
        <div className="card-measure" style={measureStyle}></div>
      </div>;
    }

    const buildContents = <div className={classNames}>
      {expansionArrow}
      <div className="card-top "> 
        {buildNameView}
      </div>
      <div className="card-footer">
        <div className="user-images-list">
            {userImageContainer}
        </div>
        <hr className={'separator ' + selectedClass + expandedClass} />
        {buttonList}
        {moreButton}
      </div>
      {action}
      {progressIndicator}
    </div>;
    const style = { width: 219, height: this.state.editBuild ? 166 : 139, left: left, top: top };
    const cardHeight = this.state.editBuild ? 141 : 114;

    return (
      <div>
        <div key={'build-card-' + displayBuild.id} id={'build-card-' + displayBuild.id} className="template-build-detail-card-outer" style={style}
          onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp}
          onMouseMove={this.handleMouseMove} ref={(element) => { this.cardElement = element; }}>
          <Card id={'card-' + displayBuild.id} width={219} height={cardHeight} left={left} top={top}
            contents={buildContents} 
            handleCardSelected={this.handleBuildSelection}
            data={displayBuild}/>
            {cardFooter}
            {menu}    
        </div>
          {this.state.displayCopyPopout && 
            <CopyBuildPopout
              handleClosePopup={this.handleCopyPopupClose}
              displayCopyPopout={this.state.displayCopyPopout}
              build={displayBuild}
            />
          }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    users: state.new_users.users,
  };
};

export default connect(mapStateToProps)(BuildDetailCard);



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTemplateHierarchy/BuildDetailCard/index.js